import { usePage } from '@inertiajs/react';
import React from 'react';
import { useSearch } from '../../hooks/useSearch';
import DriveSyncLayout from '../../layouts/DriveSyncLayout';
import DriversHeader from './DriversHeader';
import DriversTable from './DriversTable';

export default function Index() {
  const { props } = usePage();

  // Usar hook de pesquisa para motoristas
  const {
    searchTerm,
    setSearchTerm,
    searchInputRef,
    filteredItems: filteredDrivers,
    hasSearch,
    totalResults,
    totalItems: totalDrivers
  } = useSearch(props.drivers, ['name', 'carrier_name']);

  // Função para limpar busca
  const handleClearSearch = () => {
    setSearchTerm('');
  };

  return (
    <DriveSyncLayout>
      <DriversHeader
        showAddButton
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        searchInputRef={searchInputRef}
        placeholder="Pesquisar..."
        totalResults={totalResults}
        totalDrivers={totalDrivers}
        hasSearch={hasSearch}
        onClearSearch={handleClearSearch}
      />
      <DriversTable drivers={filteredDrivers} />
    </DriveSyncLayout>
  );
} 